import type { SymbolSearchResult } from '@shared/types/symbol'

import { AssetBadge } from './AssetBadge'

import { cn } from '@/utils/cn'

interface SearchResultProps {
  result: SymbolSearchResult
  isActive: boolean
  onSelect: (result: SymbolSearchResult) => void
  onHover: () => void
  id: string
}

export function SearchResultRow({ result, isActive, onSelect, onHover, id }: SearchResultProps) {
  return (
    <div
      id={id}
      role="option"
      aria-selected={isActive}
      onMouseEnter={onHover}
      onClick={() => onSelect(result)}
      className={cn(
        'flex cursor-pointer items-center gap-3 px-4 py-2 transition-colors',
        isActive ? 'bg-tv-bg-tertiary' : 'hover:bg-tv-bg-secondary'
      )}
    >
      {/* Ticker + badge */}
      <div className="flex min-w-0 flex-1 items-baseline gap-2">
        <span className="shrink-0 font-mono text-sm font-medium text-tv-text-primary">
          {result.display_ticker}
        </span>
        <span className="truncate text-xs text-tv-text-secondary">{result.name}</span>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        {result.exchange && <span className="text-2xs text-tv-text-muted">{result.exchange}</span>}
        <AssetBadge assetClass={result.asset_class} />
      </div>
    </div>
  )
}
